import React from 'react'
import { Route, Routes, Navigate } from "react-router-dom";
import { DashboardMainScreen } from '../components/private/pages/dashboard/dashboard-main/DashboardMainScreen';
import { DashboardTicketsScreen } from '../components/private/pages/dashboard/dashboard-tickets/DashboardTicketsScreen';
import { FourZeroScreen } from '../components/private/pages/404/FourZeroScreen';
import { CustomerListScreen } from '../components/private/pages/customer/CustomerListScreen';
import { CustomerDetailScreen } from '../components/private/pages/customer/CustomerDetailScreen';
import { CustomerCreateScreen } from '../components/private/pages/customer/CustomerCreateScreen';
import { ProjectListScreen } from '../components/private/pages/project/ProjectListScreen';
import { ProjectDetailScreen } from '../components/private/pages/project/ProjectDetailScreen';
import { ProjectCreateScreen } from '../components/private/pages/project/ProjectCreateScreen';
import { RecordsScreen } from '../components/private/pages/settings/RecordsScreen';
import { AccountSettingsScreen } from '../components/private/pages/settings/AccountSettingsScreen';
import { MyProfileScreen } from '../components/private/pages/settings/MyProfileScreen';
import { SettingsUsersScreen } from '../components/private/pages/settings/SettingsUsersScreen';
import { SettingsUsersCreateScreen } from '../components/private/pages/settings/SettingsUsersCreateScreen';
import { SettingsUsersEditScreen } from '../components/private/pages/settings/SettingsUsersEditScreen';
import { GroupListScreen } from '../components/private/pages/group/GroupListScreen';
import { GroupCreateScreen } from '../components/private/pages/group/GroupCreateScreen';
import { GroupDetailScreen } from '../components/private/pages/group/GroupDetailScreen';
import { SupportScreen } from '../components/private/pages/support/SupportScreen';
import { SupportTicketCreateScreen } from '../components/private/pages/support/SupportTicketCreateScreen';
import { TaskListScreen } from '../components/private/pages/task/TaskListScreen';
import { TaskCreateScreen } from '../components/private/pages/task/TaskCreateScreen';
import { TaskDetailScreen } from '../components/private/pages/task/TaskDetailScreen';
import { SearchResultsScreen } from '../components/private/pages/search/SearchResultsScreen';
import { NotificationsScreen } from '../components/private/pages/notification/NotificationsScreen';
import { AuditLogListScreen } from '../components/private/pages/audit-log/AuditLogListScreen';

export const PrivateRouter = () => {

    return (
        <Routes>
            <Route path="/" exact element={ <DashboardMainScreen /> }  />
            <Route path="/home" exact element={ <DashboardMainScreen /> }  />
            <Route path="/dashboard/tickets" exact element={ <DashboardTicketsScreen /> }  />
            
            {/* Customer */}
            <Route path="/customer/list" exact element={ <CustomerListScreen /> }  />
            <Route path="/customer/create" exact element={ <CustomerCreateScreen /> }  />
            <Route path="/customer/detail/:id" exact element={ <CustomerDetailScreen /> }  />

            {/* Project */}
            <Route path="/project/list" exact element={ <ProjectListScreen /> }  />
            <Route path="/project/create" exact element={ <ProjectCreateScreen /> }  />
            <Route path="/project/detail/:id" exact element={ <ProjectDetailScreen /> }  />

            {/* Group */}
            <Route path="/group/list" exact element={ <GroupListScreen /> }  />
            <Route path="/group/create" exact element={ <GroupCreateScreen /> }  />
            <Route path="/group/detail/:id" exact element={ <GroupDetailScreen /> }  />

            {/* Tasks */}
            <Route path="/tasks/list" exact element={ <TaskListScreen /> }  />
            <Route path="/tasks/create" exact element={ <TaskCreateScreen /> }  />
            <Route path="/tasks/detail/:ticketId" exact element={ <TaskDetailScreen /> }  />
            <Route path="/search" exact element={ <SearchResultsScreen /> }  />
            <Route path="/notifications" exact element={ <NotificationsScreen /> }  />

            {/* Settings */}
            <Route path="/settings/audit-log" exact element={ <AuditLogListScreen /> }  />
            <Route path="/settings/profile" exact element={ <MyProfileScreen /> }  />
            <Route path="/settings/records" exact element={ <RecordsScreen /> }  />
            <Route path="/settings/account" exact element={ <AccountSettingsScreen /> }  />
            <Route path="/settings/users" exact element={ <SettingsUsersScreen /> }  />
            <Route path="/settings/users/create" exact element={ <SettingsUsersCreateScreen /> }  />
            <Route path="/settings/users/edit/:userId" exact element={ <SettingsUsersEditScreen /> }  />
            <Route path="/support" exact element={ <SupportScreen /> }  />
            <Route path="/support/ticket/create" exact element={ <SupportTicketCreateScreen /> }  />

            {/* Auth */}
            <Route path="/auth/*" element={<Navigate to ="/" replace />}/>

            {/* Other */}
            <Route path="/404" exact element={ <FourZeroScreen /> }  />
            <Route path="*" element={<Navigate to ="/404" />}/>
        </Routes>
    )
}